import {
  BUSINESS_DAYS_PER_MONTH,
  HOURS_PER_DAY,
  MINUTES_PER_HOUR,
  MONTHS_PER_YEAR
} from "../../lib/constants";
import type { CustomerPortalInputs } from "./defaults";

export interface CustomerPortalResult {
  monthlyLaborValue: number;
  monthlyCost: number;
  firstYearMonthlyValue: number;
  valuePerDay: number;
  costPerDay: number;
  totalMinutesSavedPerMonth: number;
  totalDaysSavedPerMonth: number;
}

function safeNonNegative(value: number): number {
  if (!Number.isFinite(value) || value < 0) {
    return 0;
  }

  return value;
}

function safeSigned(value: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }

  return value;
}

export function calculateCustomerPortalRoi(inputs: CustomerPortalInputs): CustomerPortalResult {
  const selfServiceRatio = inputs.selfServiceTransactionPercent / 100;
  const monthlySalaryPerCsr = inputs.annualCsrSalary / MONTHS_PER_YEAR;

  const monthlyLaborValue = safeNonNegative(
    inputs.csrHeadCount * monthlySalaryPerCsr * selfServiceRatio
  );
  const monthlyCost = safeNonNegative(inputs.monthlyPrice + inputs.implementationFee / MONTHS_PER_YEAR);
  const firstYearMonthlyValue = safeSigned(monthlyLaborValue - monthlyCost);
  const valuePerDay = safeSigned(firstYearMonthlyValue / BUSINESS_DAYS_PER_MONTH);
  const costPerDay = safeNonNegative(monthlyCost / BUSINESS_DAYS_PER_MONTH);

  const totalMinutesSavedPerMonth = safeNonNegative(
    inputs.csrHeadCount *
      inputs.dailyInteractionsPerCsr *
      inputs.minutesPerInteraction *
      selfServiceRatio *
      BUSINESS_DAYS_PER_MONTH
  );

  const totalDaysSavedPerMonth = safeNonNegative(
    totalMinutesSavedPerMonth / MINUTES_PER_HOUR / HOURS_PER_DAY
  );

  return {
    monthlyLaborValue,
    monthlyCost,
    firstYearMonthlyValue,
    valuePerDay,
    costPerDay,
    totalMinutesSavedPerMonth,
    totalDaysSavedPerMonth
  };
}
